import { useEffect } from "react"
import Search from "./Search";
function Home(){

    
    return(
        <>
        <body className="body">
        
        <Search/>
        </body>
        </>
    )
}
export default Home